import React, { createContext, useState, useContext, useRef } from "react";

const GlobalStateContext = createContext<{
  isBusy: boolean;
  setBusy: React.Dispatch<React.SetStateAction<boolean>>;
  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  isUIVisible: boolean;
  setUIVisible: React.Dispatch<React.SetStateAction<boolean>>;
  ansArray: (null | string)[][];
  setAnsArray: React.Dispatch<(null | string)[][]>;
  logElements: (React.ReactElement | string)[];
  setLogElements: React.Dispatch<(React.ReactElement | string)[]>;
  hasKey: boolean;
  setHasKey: React.Dispatch<boolean>;
} | undefined>(undefined);

export const GlobalStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isBusy, setBusy] = useState<boolean>(false);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [isUIVisible, setUIVisible] = useState<boolean>(false);
  const [ansArray, setAnsArray] = useState<(null | string)[][]>([
    [],
    ["dummy", null, null, null, null, null, null, null, null],
    ["dummy", null, null, null, null, null],
    ["dummy", null, null, null, null, null, null],
    [null],
    ["dummy", null, null, null],
    [null, null, null, null],
    [null, null, null, null],
    [],
    [null]
  ]);
  const [logElements, setLogElements] = useState<(React.ReactElement | string)[]>([]);
  const [hasKey, setHasKey] = useState<boolean>(false);

  return (
    <GlobalStateContext.Provider value={{ isBusy, setBusy, currentStep, setCurrentStep, isUIVisible, setUIVisible, ansArray, setAnsArray, logElements, setLogElements, hasKey, setHasKey }}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => {
  const context = useContext(GlobalStateContext);
  if (!context) {
    throw new Error("useGlobalState must be used within a GlobalStateProvider");
  }
  return context;
};
